module.exports = __webpack_public_path__ + "img/logo_green.4a923050.png";